import { date_dmy_func } from "../../../../components/Common/CommonFunction";
import { numberWithCommas } from "../../../../Reports/Report_common_function";

export const columns = () => [
    "Wastage No",
    "Date",
    "Party Name",
    "Item Name",
    "Batch No",
    "Quantity",
    "Unit",
    "Rate",
    "Amount",
    "GST Amt",
];

// ⭐ Fallback only — real range comes from WastageReportDateRange in sessionStorage (set in printBtnHandler)
export const getDateRange = (items) => {
    if (!items.length) return { fromDate: "", toDate: "" };
    const dates = items.map(i => i.WastageDate).filter(Boolean).sort();
    return { fromDate: dates[0], toDate: dates[dates.length - 1] };
};

export const Rows = (data) => {
    const items = data.Data || [];
    const returnArr = [];

    let TotalQuantity = 0;
    let TotalAmount = 0;
    let TotalGSTAmount = 0;

    const safe = (val, dec = 2) => Number(val ?? 0).toFixed(dec);

    items.forEach((item) => {
        TotalQuantity += Number(item.Quantity) || 0;
        TotalAmount += Number(item.Amount) || 0;
        TotalGSTAmount += Number(item.GSTAmount) || 0;

        returnArr.push([
            item.WastagefullNumber || "",
            date_dmy_func ? date_dmy_func(item.WastageDate) : (item.WastageDate || ""),
            item.PartyName || "",
            item.ItemName || "",
            item.BatchNo || "",
            numberWithCommas(safe(item.Quantity, 3)),
            item.UnitName || "",
            numberWithCommas(safe(item.Rate)),
            numberWithCommas(safe(item.Amount)),
            numberWithCommas(safe(item.GSTAmount)),
            "row", // ⭐ marker at index 10, same convention as Scheme
        ]);
    });

    if (items.length > 0) {
        returnArr.push([
            "Total", "", "", "", "",
            numberWithCommas(safe(TotalQuantity, 3)),
            "", "",
            numberWithCommas(safe(TotalAmount)),
            numberWithCommas(safe(TotalGSTAmount)),
            "grandtotal", // ⭐ styled grey+bold, same as Scheme's Grand Total row
        ]);
    }

    return returnArr;
};